import { createOrderDuplicateContainer } from './container'
import { OrderDuplicateUI } from './ui/order-duplicate'

export const OrderDuplicate = createOrderDuplicateContainer(OrderDuplicateUI)
